import { render, staticRenderFns } from "./YearConfirm.vue?vue&type=template&id=f0d88c0c&scoped=true"
import script from "./YearConfirm.vue?vue&type=script&lang=ts"
export * from "./YearConfirm.vue?vue&type=script&lang=ts"
import style0 from "./YearConfirm.vue?vue&type=style&index=0&id=f0d88c0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d88c0c",
  null
  
)

export default component.exports